import React from "react";
import FeedBack from "../../component/section-feedback/feedback";


function FeedBacks() {
    return (
        <FeedBack />
    )
}
export default FeedBacks;